// Helper to capitalize each word
function capitalizeWords(str) {
  return str
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
}

// Grab all sections with data-anchor-title
const sections = document.querySelectorAll('section[data-anchor-title]');

// Collect values and filter out empty ones
const anchorTitles = Array.from(sections)
  .map(section => section.dataset.anchorTitle)
  .filter(title => title && title.trim() !== "");

// Find the .anchor-items-wrapper element
const wrapper = document.querySelector('.anchor-items-wrapper');

if (wrapper) {
  anchorTitles.forEach(title => {
    // Create a slug/id from the title (e.g. OUR ORIGIN → our-origin)
    const id = title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');

    // Ensure the section has this ID (so the link works)
    const section = Array.from(sections).find(sec => sec.dataset.anchorTitle === title);
    if (section) {
      section.id = id;
    }

    // Create the <a> link
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.className = 'anchor-item';
    link.textContent = capitalizeWords(title);

    // Append to wrapper
    wrapper.appendChild(link);
  });

  // After appending all links
  const links = wrapper.querySelectorAll('.anchor-item');

  // ✅ Add active class to the first anchor-item
  if (links.length > 0) {
    links[0].classList.add('active');
  }

  // Handle click events
  links.forEach(link => {
    link.addEventListener('click', function (e) {
      // Remove active from all
      links.forEach(l => l.classList.remove('active'));
      // Add active to the clicked one
      this.classList.add('active');
    });
  });
}
